<div [hidden]="!isLoaded">

  <mat-toolbar class="no-background">
    <span>コンタクト</span>
    <span class="spacer"></span>
    <span *ngIf="currentUser" style="font-size: 16px;">
      {{currentUser.name ? currentUser.name + ' (' + currentUser.login + ')' : currentUser.login}} 様
      <span *ngIf="currentUser.isAdmin" style="margin-left: 1em;"><button type="button" (click)="goAdmin()">管理画面へ</button></span>
    </span>
  </mat-toolbar>

  <div>

    <div class="item">
      <a [routerLink]="'/inquiry'">■お問い合わせフォーム</a>
    </div>

    <pre class="desc">１つのお問い合わせ内容につき、１件のフォーム送信をお願いいたします。
お問い合わせ内容が解決しましたら、該当のお問い合わせを　**「完了」**　としていただき、
別の質問がある場合は、新たにお問い合わせフォームから送信してください。</pre>

    <div class="item">
      <a [routerLink]="'/withdrawal'">■運用中資金の解約出金依頼フォーム</a>
    </div>

    <div class="item">
      <a [routerLink]="'/transfer'">■運用中資金の振替（スイッチング）お申込みフォーム</a>
    </div>

    <div class="item">
      <a [routerLink]="'/invest'">■新規出資のお申込みフォーム</a>
    </div>

    <pre class="desc">解約出金フォーム、振替フォーム、新規出資フォームには、ご質問を記載しないようにお願いいたします。
これらのフォームは手続き専用のため、質問を記載された場合、確認が漏れる可能性がございます。
ご質問、ご確認事項につきましては、必ずお問い合わせフォームよりお送りください。</pre>

    <div class="item">
      ※過去に Googleフォーム経由で出された依頼のキャンセルは「お問い合わせフォーム」からお願い致します<br>
    </div>

    <div class="item" style="margin-top: 2em;">
      今後、当社宛のすべてのお問い合わせ等は上記のフォームにてお受けいたします。<br>
      メールでのご連絡はご遠慮ください。<br>
      また、当社への電話連絡も一切お受けしておりません。<br>
    </div>

  </div>
</div>
